module.exports = __webpack_public_path__ + "static/img/logo-text.64b3a24.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-text.svg
// module id = 183
// module chunks = 1